import { ReactElement, useEffect, useState, SyntheticEvent } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { IDelayMeltShop, ITreeCategoryNode } from "../../../types";
import { useMsal, useAccount } from "@azure/msal-react";
import { ICategoryProcessed } from "../utils";
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import {TreeItem, TreeViewItemId} from "@mui/x-tree-view";

interface IDelayDialog {
  open: boolean;
  handleClose: any;
  // selectedNewRow: IDelay | undefined | null
  selectedNewRow: IDelayMeltShop;
  handleAccept?: any;
  categoryProcessed: ICategoryProcessed;
}

const layout = {
  paddingTop: "1em",
  display: "grid",
  height: "600px",
  gridTemplateColumns: "1fr",
  gridTemplateRows: "1fr auto auto auto"
};

const tree = {
  overflow: "auto",
  gridColumn: "1 / 1",
  gridRow: "1 / span 1",
  alignSelf: "stretch",
  margin:"0.5em 0em"
};

const textSelected = {
  // gridColumn: "1 / 1",
  // gridRow: "2 / span 1",
  alignSelf: "stretch",
  overflow: "auto",
  width: "500px",
  margin:"0.5em 0em"
};


const textComment = {
  gridColumn: "1 / 1",
  gridRow: "4 / span 1",
  alignSelf: "stretch",
  overflow: "auto",
  width: "500px",
  // height:100
};


const EditDelayDialog = ({ open, handleClose, selectedNewRow, handleAccept, categoryProcessed }: IDelayDialog): ReactElement => {
  const [selectedComment, setSelectedComment] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<ITreeCategoryNode>();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  // const [selected, setSelected] = useState<string[]>([]);
  // const [expanded, setExpanded] = useState<string[]>([]);

  const [fullName, setFullName] = useState<string>();

  useEffect(() => {
    setFullName(account ? account.name : "");
  },  [account]);


  useEffect(() => {
    if (categoryProcessed && selectedNewRow && selectedNewRow.category) {

      const selectedInfo = categoryProcessed.dictionary[selectedNewRow.category.categoryID];
      if (selectedInfo) {
        setSelectedCategory(selectedInfo);
        // setExpanded(selectedInfo.path.ids.map(id => `${id}`));
        // setSelected([ `${selectedInfo.categoryID}` ]);
      }

      setSelectedComment(selectedNewRow.comment);
    }
  }, [categoryProcessed, selectedNewRow]);


  const renderTree = (nodes: ITreeCategoryNode) =>
    <TreeItem key={`${nodes.categoryID}`} itemId={`${nodes.categoryID}`} label={nodes.name}>
      {nodes.children.map((node) => renderTree(node))}
    </TreeItem>
  ;

  const onSelectedNode = (_event: SyntheticEvent<Element, Event> | null, itemIds: TreeViewItemId[] | TreeViewItemId) => {
    if (!itemIds || (Array.isArray(itemIds) && itemIds.length === 0)) {

      return;
    }

    const idDelay = parseInt(Array.isArray(itemIds) ? itemIds[0] : itemIds, 10);

    if(categoryProcessed && idDelay  > 0) {
      const found = categoryProcessed.dictionary[idDelay];
      if (found) {
        setSelectedCategory(found);
      }
    }
  }

  const onHandleAccept =() => {
    if(!selectedCategory) {
      return;
    }

    if(selectedComment === "") {
      return;
    }

    // handleAccept(selectedNewRow.delayID,selectedIdCode,selectedComment);
    handleAccept(selectedNewRow.delayID, selectedCategory, selectedComment, fullName ? fullName : "N/A");
  };

  // const handleToggle = (event: ChangeEvent<any>, nodeIds: string[]) => {
  //   setExpanded(nodeIds);
  // };


  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Modify Delay</DialogTitle>
        <DialogContent dividers={true}>

          <div style={layout}>
            <div style={tree}>
              {categoryProcessed &&
              <SimpleTreeView multiSelect={true} onSelectedItemsChange={onSelectedNode}
                sx={{ flexGrow: 1, width: 500 }}>
                {renderTree(categoryProcessed.tree)}
              </SimpleTreeView>
              }

            </div>

            <div style={textSelected}>
              <TextField
                variant="standard"
                label="Path"
                fullWidth = {true}
                value = {selectedCategory ? selectedCategory.path.text : ""}
                slotProps={{ input: { readOnly: true, }}}
              />
            </div>

            <div style={textSelected}>
              <TextField
                variant="standard"
                label="Current Category"
                fullWidth = {true}
                value = {selectedCategory ? selectedCategory.name : ""}
                slotProps={{ input: { readOnly: true, }}}
              />
            </div>

            {/* <div style={textTime}>

              <TextField
                  style={textHhmmss}
                  label="HH"
                  type="number"
                  value={hour}
                  onChange={e=> setNewHour(Number(e.target.value)) }
                  InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: {
                      max: 10, min: 0
                  }
              }}
                />

              <TextField
                  style={textHhmmss}
                  label="MM"
                  type="number"
                  value={minutes}
                  onChange={e=> setNewMinutes(Number(e.target.value) )}
                  InputLabelProps={{
                  shrink: true,
                }} />

              <TextField
                  style={textHhmmss}
                  label="SS"
                  type="number"
                  value={seconds}
                  onChange={e=> setNewSeconds(Number(e.target.value))}
                  InputLabelProps={{
                  shrink: true,
                }} />

            </div> */}

            <div style={textComment}>

              <TextField
                variant="standard"
                label="Comments"
                id="filled-multiline-flexible"
                multiline={true}
                minRows={4}
                maxRows={4}
                value = {selectedComment}
                fullWidth={true}
                onChange={event => setSelectedComment(event.target.value)}
              />
            </div>
          </div>

        </DialogContent>
        <DialogActions>
          <Button onClick={onHandleAccept} color="primary" variant="contained" >
            Accept
          </Button>
          <Button onClick={handleClose} color="secondary" variant="contained" >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EditDelayDialog;
